import { View } from 'react-native'

import { styled } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      paddingRight: theme.paddingInsetTwopulse,
    },
    variants: {},
  }
})
